/** @jsx jsx */
import { jsx } from "theme-ui"
import React ,{ useState } from "react"
import get from "lodash/get"
import {
  Radio,
  Label,
  Input,
  Select,
  Textarea,
  Button,
  Spinner,
  Checkbox,
  Badge,
} from "@theme-ui/components"
import { useForm } from "react-hook-form"
import queryString from "query-string"
import PropTypes from "prop-types"

import Container from "./container"
import Row from "./row"
import Column from "./column"
import Text from "./text"
let textStates = {}
const Form = ({
  children,
  customStyle,
  formData,
  onSubmit,
  onSuccess,
  noSteps,
  type,
  moveToTopOnSubmit,
  sizeSQFT,
  modalClose,
  setWidth,
  downloadPlan
}) => {
  const [stepState, setStepState] = React.useState({
    step: 0,
    route: formData.defaultRoute,
    basicDetailsSet: noSteps ? true : false,
    sending: false,
    processing: false,
    sent: false,
    data: {},
    textarray: [],
  })
  const [showSomethingElse, setshowSomethingElse] = useState(false)
  const setCharCount = (e, id) => {
    textStates[id] = e.target.value.length
  }

  const { register, handleSubmit, watch,unregister, errors } = useForm({
    mode: "onChange",
    submitFocusError: false,
  })

  const watches = watch(["form"])
  const validateQuestionCondition = (question, data) =>
    question.conditionQuestion
      ? question.conditionAnswers.includes(
        get(data ? data : watches, `form._${question.conditionQuestion}`)
      )
      : true
  let currentQuestions = get(
    formData.routes,
    `${stepState.route}.questions`,
    []
  ).map(question => (validateQuestionCondition(question) ? question : null))
  if (!noSteps)
    currentQuestions = currentQuestions.slice(
      0,
      stepState.step >= 0 ? stepState.step + 1 : 0
    )
  // const lastCurrentQuestion = currentQuestions[currentQuestions.length - 1]

  let checkIndex = currentQuestions.length;
  while (checkIndex-- && !currentQuestions[checkIndex]);
  const lastCurrentQuestion = currentQuestions[checkIndex] 
  const isLastQuestion = stepState.route
    ? formData.routes[stepState.route].questions[
    formData.routes[stepState.route].questions.length - 1
    ] === lastCurrentQuestion || lastCurrentQuestion?.islastquestion === true
    : false
  const isButtonDisabled = lastCurrentQuestion?.buttonDisable === true || false
  const isButtonRemove = lastCurrentQuestion?.buttonRemove === true || false
  const renderSelectionButton = (buttonType, currentType, handler) => {
    return (
      <Button
        variant="forms.buttonSelection"
        onClick={() => {
          handler(buttonType)
        }}
        type="button"
        sx={{
          bg: () => (currentType === buttonType ? "primary" : "secondary"),
          textAlign: "left",
        }}
      >
        {buttonType}
      </Button>
    )
  }
  const renderBasicQuestions = () => {
    const styles = {
      label:
        type === "secondary"
          ? {
            mb: 1,
            mt: type === "secondary" ? 3 : 0,
            fontSize: 2,
            fontWeight: "bold",
          }
          : { mb: 1 },
    }
    return (
      <Row customStyle={{ mb: 4 }}>
        <Column size={type === "secondary" ? [12, 12, 6, 6] : [12, 12, 6, 4]}>
          <Label sx={{ ...styles.label }}>First Name</Label>
          <Input
            name="form.basicDetails.firstName"
            ref={register({
              required: "required",
            })}
            variant={
              get(errors, "form.basicDetails.firstName")
                ? "forms.inputError"
                : "forms.input"
            }
          />
        </Column>
        <Column size={type === "secondary" ? [12, 12, 6, 6] : [12, 12, 6, 4]}>
          <Label sx={{ ...styles.label }}>Last Name</Label>
          <Input
            name="form.basicDetails.lastName"
            ref={register({
              required: "required",
            })}
            variant={
              get(errors, "form.basicDetails.lastName")
                ? "forms.inputError"
                : "forms.input"
            }
          />
        </Column>
        <Column size={type === "secondary" ? [12, 12, 6, 6] : [12, 12, 6, 4]}>
          <Label sx={{ ...styles.label }}>Email Address</Label>
          <Input
            name="form.basicDetails.email"
            ref={register({
              required: "required",
              pattern: /^\S+@\S+$/i,
            })}
            variant={
              get(errors, "form.basicDetails.email")
                ? "forms.inputError"
                : "forms.input"
            }
          />
        </Column>
      </Row>
    )
  }

  const displayCheckboxOptions = text => {
    let textarr = text.split(":")
    return (
      <p sx={{ mb: 0 }}>
        {textarr[0].includes("Lot") ? (
          <>
            <span sx={{ fontWeight: "bold" }}>{`${textarr[0]}`}</span>
            <Badge variant="circle" style={{ marginLeft: "4px", position:"relative", top:"-1px" }}>
              Beta
            </Badge>
          </>
        ) : (
          <span sx={{ fontWeight: "bold" }}>{`${textarr[0]}`}</span>
        )}

        {textarr?.length > 1 && <span>{`:${textarr[1]}`}</span>}
      </p>
    )
  }
  const renderSomethingElse = (event, name) => {
    if (event.target.value === "Something else" && event.target.checked) {
      setshowSomethingElse(true)
    } else if (
      event.target.value === "Something else" &&
      !event.target.checked
    ) {
      unregister("form._contact_form_info")
      setshowSomethingElse(false)
    }
  }

  const renderQuestion = question => {
    let name = `form._${question.id}`
    let lineBreak = question.question.split('<br/>')
    return (
      <Row customStyle={{ mb: 4 }}>
        <Column size={[12, 12, 12]}>
          {question.question && (
            <>
              {lineBreak.length > 1 ?
                <>
                  <Text type="h3" customStyle={{ mb: 2 }}>
                    {lineBreak[0]}
                  </Text>
                  <Text type="h3" customStyle={{ mb: 2 }}>
                    {lineBreak[1]}
                  </Text>
                </>
                :
                <Text type="h3" customStyle={{ mb: 2 }}>
                  {question.question}
                </Text>
              }
            {question.questionParagraph ? (
                  <Text customStyle={{ mb: 3 }}>
                    {question.questionParagraph}
                  </Text>
                ) : null}
            </>
          )}
        </Column>
        <Column size={[12, 12, 12]}>
          {question.type === "input" ? (
            <Input
              name={name}
              {...(question.required
                ? {
                  ref: register({
                    required: "required",
                  }),
                  variant: get(errors, name)
                    ? "forms.inputError"
                    : "forms.input",
                }
                : { ref: register({}) })}
            />
          ) : null}
          {question.type === "phone" ? (
            <Input
              name={name}
              {...(question.required
                ? {
                  ref: register({
                    required: "required",
                    minLength: 10,
                    pattern: /^[0-9+()-].+$/i,
                  }),
                  variant: get(errors, name)
                    ? "forms.inputError"
                    : "forms.input",
                }
                : {
                  ref: register({ minLength: 10, pattern: /^[0-9.].+$/i }),
                })}
            />
          ) : null}
          {question.type === "price" ? (
            <>
              <Text type="h4" customStyle={{ my: 2 }}>
                Price Per Square Foot $
              </Text>
              <Input
                name={name}
                {...(question.required
                  ? {
                    ref: register({
                      required: "required",
                      pattern: /^[0-9.].+$/i,
                    }),
                    variant: get(errors, name)
                      ? "forms.inputError"
                      : "forms.input",
                  }
                  : { ref: register({ pattern: /^[0-9.].+$/i }) })}
              />
            </>
          ) : null}
          {question.type === "numberUnit" ? (
            <Input
            type="number"
            name={name}
            {...(question.required
              ? {
                ref: register({
                  required: "required",
                  // pattern: /^([1-4][0-9][0-9]|[0-9][0-9]|[1-9]|500)$/i
                  pattern: /^([2-9]|[1-9][0-9]|[1-9][0-9][0-9]|1000)$/i
                }),
                variant: get(errors, name)
                  ? "forms.inputError"
                  : "forms.input",
              }
              : { ref: register({ pattern: /^([2-9]|[1-9][0-9]|[1-9][0-9][0-9]|1000)$/i }) })}
          />
          ) : null}
          {question.type === "location" ? (
            <Row>
              <Column size={[12, 12, 12, 12]}>
                <Label sx={{ mb: 1 }}>Country</Label>
                <Select
                  name={`${name}.country`}
                  ref={register({
                    required: "required",
                  })}
                  defaultValue="US"
                >
                  <option value="US">United States</option>
                </Select>
              </Column>
              <Column size={[12, 12, 12, 12]}>
                <Label sx={{ mb: 1 }}>Street</Label>
                <Input
                  name={`${name}.address`}
                  ref={register({})}
                  variant={
                    get(errors, `${name}.address`)
                      ? "forms.inputError"
                      : "forms.input"
                  }
                />
              </Column>
              <Column size={[12, 12, 6, 4]}>
                <Label sx={{ mb: 1 }}>City</Label>
                <Input
                  name={`${name}.city`}
                  ref={register({
                    required: "required",
                  })}
                  variant={
                    get(errors, `${name}.city`)
                      ? "forms.inputError"
                      : "forms.input"
                  }
                />
              </Column>
              <Column size={[12, 12, 6, 4]}>
                <Label sx={{ mb: 1 }}>State</Label>
                <Select
                  name={`${name}.state`}
                  ref={register({
                    required: "required",
                    validate: value => value !== "_",
                  })}
                  variant={
                    get(errors, `${name}.state`)
                      ? "forms.selectError"
                      : "forms.select"
                  }
                  defaultValue="_"
                >
                  <option value="_" disabled>
                    {formData.dropdownPlaceholderText}
                  </option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </Select>
              </Column>
              <Column size={[12, 12, 6, 4]}>
                <Label sx={{ mb: 1 }}>Zip</Label>
                <Input
                  name={`${name}.zip`}
                  ref={register({
                    required: "required",
                    pattern: /^[0-9].+$/i,
                  })}
                  variant={
                    get(errors, `${name}.zip`)
                      ? "forms.inputError"
                      : "forms.input"
                  }
                />
              </Column>
            </Row>
          ) : null}
          {question.type === "planLocation" ? (
            <>
                <Label sx={{ mb: 1 }}>Country</Label>
                <Select
                  name={name}
                  ref={register({
                    required: "required",
                  })}
                  defaultValue="US"
                >
                  <option value="US">United States</option>
                </Select>
              </>
          ) : null}
          {question.type === "planLocationState" ? (
            <>
              <Label sx={{ mb: 1 }}>State</Label>
              <Select
              defaultValue={question.defaultAnswer || "_"}
              name={name}
              ref={register({
                required: true,
                validate: value => value !== "_",
              })}
              variant={get(errors, name) ? "forms.selectError" : "forms.select"}
            >
              {!question.defaultAnswer && (
                <option value="_" disabled>
                  {formData.dropdownPlaceholderText}
                </option>
              )}
              {question.answers.map((answer, index) => (
                <option key={index} value={answer.value}>
                  {answer.text}
                </option>
              ))}
            </Select>
            </>
          ) : null}
          {question.type === "textarea" ? (
            <React.Fragment>
              <Textarea
                name={name}
                {...(question.required
                  ? {
                    ref: register({
                      required: "required",
                    }),
                    variant: get(errors, name)
                      ? "forms.textareaError"
                      : "forms.textarea",
                  }
                  : { ref: register({}) })}
                onChange={e => setCharCount(e, question.id)}
              />
              <span
                style={{
                  fontWeight: 600,
                  color:
                    textStates &&
                      textStates[question.id] &&
                      textStates[question.id] > 500
                      ? "red"
                      : "black",
                  paddingLeft: "8px",
                  fontFamily: "Helvetica Neue,sans-serif",
                }}
              >
                {textStates && textStates[question.id]
                  ? textStates[question.id]
                  : 0}
                /500
              </span>
            </React.Fragment>
          ) : null}
          {(question.type === "contact")  ? (
              <Row customStyle={{ px: [0, 0, null, null] }}>
              <Column size={[12, 12, 6, 6]}>
                <Label sx={{ mb: 1 }}>First Name</Label>
                <Input
                  name={`${name}.first_name`}
                  ref={register({
                    required: "required",
                  })}
                  variant={
                    get(errors, `${name}.first_name`)
                      ? "forms.inputError"
                      : "forms.input"
                  }
                />
              </Column>
              <Column size={[12, 12, 6, 6]}>
                <Label sx={{ mb: 1 }}>Last Name</Label>
                <Input
                  name={`${name}.last_name`}
                  ref={register({
                    required: "required",
                  })}
                  variant={
                    get(errors, `${name}.last_name`)
                      ? "forms.inputError"
                      : "forms.input"
                  }
                />
              </Column>
              <Column size={[12, 12, 12,12]}>
                <Label sx={{ mb: 1 }}>Email</Label>
                <Input
                  name={`${name}.email`}
                  ref={register({
                    required: "required",
                    pattern: /^\S+@\S+$/i,
                  })}
                  variant={
                    get(errors,`${name}.email`)
                      ? "forms.inputError"
                      : "forms.input"
                  }
                />
              </Column>
              {( question.contactType ==="full") ? (
                <>
                <Column size={[12, 12, 6, 6]}>
                <Label sx={{ mb: 1 }}>Company Name</Label>
                <Input
                  name={`${name}.company`}
                  ref={register({
                    required: "required",
                  })}
                  variant={
                    get(errors, `${name}.company`)
                      ? "forms.inputError"
                      : "forms.input"
                  }
                />
              </Column>
              <Column size={[12, 12, 6, 6]}>
                <Label sx={{ mb: 1 }}>Phone</Label>
                <Input
                  name={`${name}.phone`}
                  ref={register({
                    required: "required",
                    pattern: /^[0-9].+$/i,
                    minLength: 10,
                  })}
                  variant={
                    get(errors, `${name}.phone`)
                      ? "forms.inputError"
                      : "forms.input"
                  }
                />
              </Column>
                </>
              ): null}
              
            </Row>
            ) :  null}
          {question.type === "select" ? (
            <Select
              defaultValue={question.defaultAnswer || "_"}
              name={name}
              ref={register({
                required: true,
                validate: value => value !== "_",
              })}
              variant={get(errors, name) ? "forms.selectError" : "forms.select"}
            >
              {!question.defaultAnswer && (
                <option value="_" disabled>
                  {formData.dropdownPlaceholderText}
                </option>
              )}
              {question.answers.map((answer, index) => (
                <option key={index} value={answer.value}>
                  {answer.text}
                </option>
              ))}
            </Select>
          ) : null}
          {question.type === "radio"
            ? question.answers.map((option, index) => (
              <Label key={index}>
                <Radio
                  name={name}
                  value={option.value}
                  {...(option.value === question.defaultAnswer
                    ? { defaultChecked: "checked" }
                    : {})}
                  ref={register({ required: true })}
                />
                {option.text}
              </Label>
            ))
            : null}
          {question.type === "checkbox"
              ? <>
                {get(errors, name) ? 
                // <Text type="h3" color={"red"} customStyle={{ mb: 2 }}>
                // This field is required.
                // </Text>
                <Label 
                sx={{div: {minWidth: [32],},}}
                style={{ color: "red"}}
                >
                  This field is required.
                  </Label>
                : null}
              {question.answers.map((option, index) => (
                  <>
                    <Label
                      key={index}
                      sx={{
                        div: {
                          minWidth: [32],
                        },
                      }}
                    >
                      <Checkbox
                        name={name}
                        value={option.value}
                        {...(option.value === question.defaultAnswer
                          ? { defaultChecked: "checked" }
                          : {})}
                        ref={register({ required: true })}
                        onChange={e => renderSomethingElse(e, name)}
                      />
                      {displayCheckboxOptions(option.text)}
                    </Label>
                    {showSomethingElse &&
                    option.text.match(/Something else/i) ? (
                      <>
                        {" "}
                        <Textarea
                          name="form._contact_form_info"
                          {...{
                            ref: register({
                              required: "required",
                            }),
                            variant: get(errors, "form._contact_form_info")
                              ? "forms.textareaError"
                              : "forms.textarea",
                          }}
                          onChange={e => setCharCount(e, question.id)}
                        />
                        <span
                          style={{
                            fontWeight: 600,
                            color:
                              textStates &&
                              textStates[question.id] &&
                              textStates[question.id] > 500
                                ? "red"
                                : "black",
                            paddingLeft: "8px",
                            fontFamily: "Helvetica Neue,sans-serif",
                          }}
                        >
                          {textStates && textStates[question.id]
                            ? textStates[question.id]
                            : 0}
                          /500
                        </span>
                      </>
                    ) : null}
                  </>
                ))}
                </>
              : null}
        </Column>
      </Row>
    )
  }
  // const renderRouteSelector = () => (
  //   <Row customStyle={{ mb: 4 }}>
  //     <Column size={[12, 12, 12]}>
  //       <Text type="h3" customStyle={{ mb: 2 }}>
  //         What best describes you?
  //       </Text>
  //     </Column>
  //     <Row
  //       customStyle={{
  //         mx: 1,
  //         width: "100%",
  //       }}
  //     >
  //       {Object.keys(formData.routes)
  //         .sort((a, b) => formData.routes[a].order - formData.routes[b].order)
  //         .map((buttonType, index) => (
  //           <Column
  //             key={index}
  //             size={[12, 6, 4, 3]}
  //             customStyle={{
  //               flexWrap: "wrap",
  //               my: 2,
  //               pl: "6px",
  //               maxWidth: [
  //                 "100%",
  //                 "50%",
  //                 type === "secondary" ? `${100 / 3}%` : "25%",
  //                 type === "secondary" ? `${100 / 3}%` : "20%",
  //               ],
  //               flexBasis: [
  //                 "100%",
  //                 "50%",
  //                 type === "secondary" ? `${100 / 3}%` : "25%",
  //                 type === "secondary" ? `${100 / 3}%` : "20%",
  //               ],
  //             }}
  //           >
  //             {renderSelectionButton(buttonType, stepState.route, changeRoute)}
  //           </Column>
  //         ))}
  //     </Row>
  //   </Row>
  // )

  const renderRouteSelector = () => (
    <Row
      customStyle={{
        mb: 4,
      }}
    >
      <Column size={[12, 12, 12]}>
        <>
          <Text type="h3" customStyle={{ mb: 2 }}>
          {formData.routesQuestion ? 
          <span>{formData.routesQuestion}</span>
          : 
          <span>What best describes your role in the project?</span>
           }
          </Text>
        </>
      </Column>
      <Column size={[12, 12, 12]}>
        <Select
          defaultValue={"_"}
          name="Initial Project Type"
          customStyle={{ width: "100%" }}
          onChange={e => changeRoute(e.target.value)}
          ref={register({
            required: true,
            validate: value => value !== "_",
          })}
          variant={
            get(errors, "Initial Project Type") ? "forms.selectError" : "forms.select"
          }
        >
          <option value="_" disabled>
            {formData.dropdownPlaceholderText}
          </option>
          {Object.keys(formData.routes)
            .sort((a, b) => formData.routes[a].order - formData.routes[b].order)
            .map((answer, index) => {
              return (
                <option key={index} value={answer.value}>
                  {answer}
                </option>
              )
            })}
        </Select>
      </Column>
    </Row>
  )
  const doNextStep = data => {
    if (!stepState.basicDetailsSet) {
      setStepState({ ...stepState, basicDetailsSet: true })
    } else if (stepState.route) {
      let nextStep = stepState.step + 1
      while (
        nextStep < formData.routes[stepState.route].questions.length &&
        !validateQuestionCondition(
          formData.routes[stepState.route].questions[nextStep],
          data
        )
      ) {
        nextStep++
      }
      setStepState({ ...stepState, step: nextStep })
    }
  }
  const changeRoute = type => {
    setStepState({ ...stepState, step: 0, route: type })
  }
  const checkIsLastQuestion = async data => {
    let isMax = false
    for (let char in textStates) {
      if (textStates[char] > 500) isMax = true
    }
    if (isMax) return
    if (isLastQuestion && data.form) {
      if (moveToTopOnSubmit)
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" })
      setStepState({ ...stepState, sending: true, data })
    } else {
      doNextStep(data)
    }
  }
  const resetForm = () =>{
    if(typeof downloadPlan !== 'undefined'){
      downloadPlan()
    }
    if(typeof modalClose !== 'undefined'){
      modalClose()
    }
    setStepState({
      step: 0,
      route: formData.defaultRoute,
      basicDetailsSet: noSteps ? true : false,
      sending: false,
      processing: false,
      sent: false,
      data: {},
      textarray: [],
    })
  }
  React.useLayoutEffect(() => {
    const submitGA = () => {
      window &&
        window.gtag &&
        window.gtag("event", "Form submission", {
          event_label: formData.gaEventLabel,
          event_category: "Event",
          non_interaction: true,
        })

      /* For google converion apis */
      window &&
        window.gtag &&
        window.gtag("event", "conversion", {
          send_to: `AW-799114647/${formData.conversionDetail}`,
          value: 1.0,
          currency: "USD",
        })
      // window &&
      //   window.gtag && window.gtag('config', 'AW-799114647');
    }
    
    const sendForm = async data => {
      
      let requestData = {
        ...formData.defaultFields,
      }
      // requestData["00N8c00000bpPYh"] =  requestData['Email Opt In'];
      // delete requestData['Email Opt In']
      const referralLink =
        type === "secondary"
          ? window.location.href
          : queryString.parse(window.location.search).ref
      if (formData.referralLinkField && referralLink) {
        requestData[formData.referralLinkField] = referralLink
      }
      // if (formData.basicQuestions)
      //   requestData = {
      //     ...requestData,
      //     first_name: data.form.basicDetails.firstName,
      //     last_name: data.form.basicDetails.lastName,
      //     email: data.form.basicDetails.email,
      //   }
      if (formData.routes[stepState.route].hiddenFields) {
        requestData = {
          ...requestData,
          ...formData.routes[stepState.route].hiddenFields,
        }
      }
      for (const question of currentQuestions) {
        if (question && question.id) {
          const answer = get(data, `form._${question.id}`)
          if (answer && question.type !== "location") {
            if (Array.isArray(answer)) {
              if(question.type=== "checkbox"){
                let temp = []
                temp["00N8c00000bqfPU"] = (answer.includes("Req Design Review")) ? true : false; 
               	temp["00N8c00000bqfPe"] = (answer.includes("Req General Info")) ? true : false;
               	temp["00N8c00000bqfOc"] = (answer.includes("Req Design Consult")) ? true : false;
                requestData = {...requestData, ...temp};
              }else{
                let answerString = answer.join()
                requestData[question.fieldName] = answerString;
                requestData = {...requestData}
              }
              
            }else if(typeof answer === 'object' && question.contactType){
              let temp = []
              temp["first_name"] = answer.first_name
              temp["last_name"] = answer.last_name
              temp["email"] = answer.email
              if(answer.company){
                temp["company"] = answer.company;
                temp["phone"] = answer.phone
              }
              requestData = {...requestData, ...temp}
            } else {
              requestData[question.fieldName] = answer
            }
            requestData[question.fieldName] = answer
          } else if (answer) {
            // requestData.state = get(data, `form._${question.id}.state`)
            // requestData.city = get(data, `form._${question.id}.city`)
            // requestData.address = get(data, `form._${question.id}.address`)
            // requestData.country = get(data, `form._${question.id}.country`)
            // requestData.zip = get(data, `form._${question.id}.zip`)
            requestData["00N8c00000bpWMT"] = get(data, `form._${question.id}.state`)
            requestData["00N8c00000bpWMO"] = get(data, `form._${question.id}.city`)
            requestData["00N8c00000bpWM9"] = get(data, `form._${question.id}.address`)
            requestData["00N8c00000bpWMn"] = get(data, `form._${question.id}.country`)
            requestData["00N8c00000bpWMs"] = get(data, `form._${question.id}.zip`)
          }
        }
      }
      delete requestData.Contact;
      
      if (get(data, `form._contact_form_info`)) {
        // requestData["Contact Form Info"] = get(data, `form._contact_form_info`)
        requestData["00N8c00000bqfPo"] = get(data, `form._contact_form_info`)
      }
      
      if (localStorage.getItem("parameter")) {
        let urlformdata = JSON.parse(localStorage.getItem("formObj"))
        // requestData = {
        //   ...requestData,
        //   ...urlformdata,
        // }
        if(urlformdata && urlformdata['gclid']) {
          requestData['00N8c00000dpAuR'] =  urlformdata['gclid']
        }
      }
      if (onSubmit) {
        // Converting to JSON
        // .then(response => response.json())

        // // Displaying results to console
        // .then(json => console.log("resdat",json));

        onSubmit(requestData)
      }
      submitGA()
      if(requestData["Info Request"]) requestData["Info Request"] = requestData["Info Request"].join(",")
      if(requestData["00N8c00000bnWeh"] === "Owner") requestData["00N8c00000bohb6"] = sizeSQFT
      requestData["00N8c00000g15eC"] = (requestData["00N8c00000g15eC"])  ? requestData["00N8c00000g15eC"] : "Yes" 
      // if(requestData["00N8c00000bnWYO"]) requestData["00N8c00000bnWYO"] = requestData["00N8c00000bnWYO"] === "Yes" ? true : false
      delete requestData['Info Request']
      delete requestData['']
      if(requestData["undefined"]) delete requestData["undefined"]
      textStates = {}
      let response
      let res
      if (formData.method === "GET") {
        if (formData.callOnlyloggerUrl) {
          // logger api call

          res = await fetch(
            queryString.stringifyUrl(
              {
                url: "https://api.plantprefab.com/v1/logger/",
                query: requestData,
              },
              { encode: true, sort: false },
              {
                method: "GET",
                // headers: {
                //   'Content-Type': 'text/html',
                //   'access-control-allow-origin': '*',
                // },
              }
            )
          )
            .then(response => response.json())
            .catch(error => console.log("Request failed", error))
        } else {
          // logger api call

          res = await fetch(
            queryString.stringifyUrl(
              {
                url: "https://api.plantprefab.com/v1/logger/",
                query: requestData,
              },
              { encode: true, sort: false },
              {
                method: "GET",
                // headers: {
                //   'Content-Type': 'text/html',
                //   'access-control-allow-origin': '*',
                // },
              }
            )
          )
            .then(response => response.json())
            .catch(error => console.log("Request failed", error))

          // agile Crm api call

          // response = await fetch(
          //   queryString.stringifyUrl(
          //     { url: formData.url, query: requestData },
          //     { encode: true, sort: false }
          //   ),
          //   {
          //     method: "GET",
          //   }
          // )

          if(formData.SalesforceUrl){
            let requestOptions = {
              method: 'POST',
              body: JSON.stringify(requestData)
            };
            
           
            let resp = await fetch(formData.SalesforceUrl, requestOptions);
            let data = await resp.json();
           
            // if( resp.status !== 200 ){
              response = data;
            //   response.status =  resp.status
            // }
          }
        }

        // Promise.all([res,response]);
      }

      if (formData.callOnlyloggerUrl) {
        // console.log("res-->",res);
        if (res === "Success!") {
          if (onSuccess) onSuccess(requestData)
         if(modalClose) modalClose(); setStepState({ ...stepState, sending: false, sent: true })
        }
      } else {
        if (response === "SFDC Post Successful!") {
          if (onSuccess) onSuccess(requestData)
         if(modalClose) modalClose(); setStepState({ ...stepState, sending: false, sent: true })
        }
      }
    }

    if (stepState.sending && !stepState.processing) {
      sendForm(stepState.data)
      setStepState({ ...stepState, processing: true })
    }
  }, [stepState, currentQuestions, formData, onSubmit, onSuccess, type])

  return (
    <Container customStyle={{ ...customStyle }}>
      {!(stepState.sent || stepState.sending) ? children : null}
      {
      typeof formData.thankYouMessageDisable === "undefined" && stepState.sent && !modalClose ? (
        <Text
          className="thankyoumessage"
          dangerouslySetInnerHTML={{ __html: formData.thankYouMessage }}
        ></Text>
      ) : 
      stepState.sending ? (
        <Spinner />
      ) : (
        <form onSubmit={handleSubmit(checkIsLastQuestion)} style={{width:setWidth ? setWidth : ""}}>
          {/* {formData.basicQuestions ? renderBasicQuestions() : null} */}
          { Object.keys(formData.routes).length > 1
            ? renderRouteSelector()
            : null}
          {currentQuestions.map((question, index) => (
            <div key={index}>{question && renderQuestion(question)}</div>
          ))}
          {!stepState.basicDetailsSet ? (
            <Button type="submit" variant="forms.buttonChevron">
              {formData.initialButtonText}
            </Button>
          ) : null}
          {/* {stepState.basicDetailsSet &&
            stepState.route &&
            type !== "secondary" ? (
            <Button type="submit" variant="forms.buttonChevron">
              {isLastQuestion
                ? formData.submitButtonText
                : formData.nextButtonText}
            </Button>
          ) : null} */}
          {isButtonRemove === false && isLastQuestion === true && type === "secondary" && isButtonDisabled === false ? (
            <Button
              type="submit"
              variant="forms.buttonChevron"
              sx={{ background: stepState.route ? null : "#888" }}
              disabled={!stepState.route}
            >
              {formData.submitButtonText}
            </Button>
          ) : (isButtonRemove === false && isLastQuestion === true && type === "secondary" && isButtonDisabled === true ) ?
          <Button
              type="button"
              variant="forms.buttonChevron"
              sx={{ background: stepState.route ? null : "#888" }}
              disabled={!stepState.route}
              onClick={resetForm}
            >
              {formData.buttonDisableText || "Reset Form"}
            </Button>
             : null}
        </form>
      )}
    </Container>
  )
}
Form.propTypes = {
  children: PropTypes.node,
  customStyle: PropTypes.object,
  formData: PropTypes.object,
  onSubmit: PropTypes.func,
  onSuccess: PropTypes.func,
}
export default Form
